<script>
import {mapActions} from "vuex";

import EditEntryPatternModal from "@/driver/pages/masters/emissions/dialogs/EditEntryPatternModal.vue";
import ShowEntryPatternModal from "@/driver/pages/masters/emissions/dialogs/ShowEntryPatternModal.vue";
import Confirm from "@/components/Confirm.vue";

export default {
  name: "EmissionEntryPattern",
  components: {
    Confirm,
    EditEntryPatternModal,
    ShowEntryPatternModal
  },
  props: {
    emission: {
      type: Object,
      default: () => {},
    },
  },
  data () {
    return {
      entryPatterns: [],
      page: 1,
      totalVisible: 7,
      pagination: {
        total_pages: 0,
        total_count: 0
      },
      tableHeaders: [
        { value: 'order_type', text: '登録種別', width: '7%', align: 'center' },
        { value: 'pattern_name', text: 'パターン名\r\nマニ区分', width: '16%' },
        { value: 'location', text: '事業場', width: '19%' },
        { value: 'item', text: '取扱品目\r\n荷姿', width: '11%' },
        { value: 'transport_route', text: 'ルート\r\n処分事業場', width: '18%' },
        { value: 'sort_priority', text: '表示順', width: '4%' },
        { value: 'editable', text: '', align: 'end', width: '13%' },
      ],
      enableEditEntryPatternModal: false,
      enableDetailEntryPatternModal: false,
      targetId: null,
      targetOrderType: null,
    }
  },
  created() {
    if (this.emission.id) {
      this.page = 1;
      this.searchEmissionEntryPatterns();
    }
  },
  methods: {
    ...mapActions("DriverMasterEmissionEntryPattern", {
      fetchEntryPatterns: "index",
      deleteEntryPattern: "destroy"
    }),
    /**
     * 詳細ボタン クリックイベント
     * @param item
     */
    detailButtonClickEvent (item) {
      this.targetId = item.id;
      this.targetOrderType = item.order_type;
      this.enableDetailEntryPatternModal = true;
    },
    /**
     * 追加ボタン クリックイベント
     */
    addButtonClickEvent () {},
    /**
     * 編集ボタン クリックイベント
     * @param item
     */
    editButtonClickEvent (item) {
      this.targetId = item.id;
      this.targetOrderType = item.order_type;
      this.enableEditEntryPatternModal = true;
    },
    /**
     * 削除ボタン クリックイベント
     * @param item
     */
    deleteButtonClickEvent (item) {
      this.$refs.confirm.showDeleteConfirm().then((confirm) => {
        this.$refs.confirm.close()
        if (confirm) {
          this.deleteEntryPattern({ emission_id: this.emission.id, id: item.id }).then(() =>{
            this.page = 1
            this.searchEmissionEntryPatterns()
          })
        }
      })
    },
    /**
     * ページ チェンジイベント
     */
    pageChangeEvent () {
      this.searchEmissionEntryPatterns();
    },
    /**
     * 一覧検索処理
     */
    searchEmissionEntryPatterns () {
      this.fetchEntryPatterns({ id: this.emission.id, page: this.page }).then((content) => {
        this.entryPatterns = content.entry_patterns;
        this.pagination = content.pagination
      })
    },

    registerCallback () {
      this.searchEmissionEntryPatterns();
      this.closeModal();
    },
    closeModal () {
      this.enableEditEntryPatternModal = false;
      this.enableDetailEntryPatternModal = false;
    }

  }

}
</script>

<template>
  <div>
    <v-card flat>
      <v-toolbar v-if="false" flat>
        <v-spacer />
          <v-btn color="primary" @click="addButtonClickEvent">追加</v-btn>
      </v-toolbar>
      <v-card-text class="pt-3">
        <v-sheet outlined rounded>
          <v-data-table
            :headers="tableHeaders"
            :items="entryPatterns"
            :items-per-page="-1"
            dense
            disable-sort
            hide-default-footer
          >
            <!-- 登録種別 -->
            <template v-slot:[`item.order_type`]="{ item }">
              {{ item.order_type | short_order_type_label }}
            </template>
            <!-- /登録種別 -->

            <!-- パターン名 -->
            <template v-slot:[`item.pattern_name`]="{ item }">
              <div
                :title="item.name"
                class="line-clamp one-clamp"
              >
                {{ item.name }}
              </div>
              <div>
                {{ item.manifest_type | short_manifest_type_label }}
              </div>
            </template>
            <!-- /パターン名 -->

            <!-- 排出事業場名 -->
            <template v-slot:[`item.location`]="{ item }">
              <div
                :title="item.emission_location_name"
                class="line-clamp one-clamp"
              >
                {{ item.emission_location_name }}
              </div>
            </template>
            <!-- /排出事業場名 -->
            <template v-slot:[`item.sort_priority`]="{ item }">
              <div class="text-right">
                {{ item.sort_priority }}
              </div>
            </template>
            <template v-slot:[`item.item`]="{ item }">
              <div>
                <v-chip
                  v-if="item.item_name"
                  :title="item.item_name"
                  color="#F0E6D0"
                  drak
                  label
                  x-small
                  class="chip-ellipsis"
                >
                  <small>{{ item.item_name }}</small>
                </v-chip>
                <template v-else>&nbsp;</template>
              </div>
              <div>
                <small>
                  {{ item.packing_name }}&nbsp;全{{ item.item_count }}件
                </small>
              </div>
            </template>
            <template v-slot:[`item.transport_route`]="{ item }">
              <div
                :title="item.transport_route_name"
                class="line-clamp one-clamp"
              >
                {{ item.transport_route_name }}
              </div>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <div
                    v-bind="attrs"
                    v-on="on"
                    class="line-clamp one-clamp"
                  >
                    {{ item.disposer_location_name }}
                  </div>
                </template>
                <div><strong>{{ item.disposer_name }}</strong></div>
                <div>{{ item.disposer_location_name }}</div>
                <div>{{ item.disposer_location_address }}</div>
              </v-tooltip>
            </template>
            <template v-slot:[`item.editable`]="{ item }">
              <v-btn
                :icon="$vuetify.breakpoint.mdAndUp"
                :small="$vuetify.breakpoint.smAndDown"
                :outlined="$vuetify.breakpoint.smAndDown"
                :color="`info ${$vuetify.breakpoint.mdAndUp ? 'darken-2': null}`"
                :class="{ 'mr-2': $vuetify.breakpoint.smAndDown }"
                @click="detailButtonClickEvent(item)"
              >
                <v-icon v-if="$vuetify.breakpoint.mdAndUp">
                  mdi-file-document-outline
                </v-icon>
                <span v-else>参照</span>
              </v-btn>
              <v-btn
                :icon="$vuetify.breakpoint.mdAndUp"
                :small="$vuetify.breakpoint.smAndDown"
                :color="`info ${$vuetify.breakpoint.mdAndUp ? 'darken-2': null}`"
                :class="{ 'mr-2': $vuetify.breakpoint.smAndDown }"
                @click="editButtonClickEvent(item)"
              >
                <v-icon v-if="$vuetify.breakpoint.mdAndUp">
                  mdi-file-edit-outline
                </v-icon>
                <span v-else>編集</span>
              </v-btn>
              <v-btn
                :icon="$vuetify.breakpoint.mdAndUp"
                :small="$vuetify.breakpoint.smAndDown"
                :color="`error ${$vuetify.breakpoint.mdAndUp ? 'darken-2': null}`"
                @click="deleteButtonClickEvent(item)"
              >
                <v-icon v-if="$vuetify.breakpoint.mdAndUp">
                  mdi-trash-can-outline
                </v-icon>
                <span v-else>削除</span>
              </v-btn>
            </template>
          </v-data-table>
        </v-sheet>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-pagination
          v-model="page"
          :length="pagination.total_pages"
          :total-visible="totalVisible"
          circle
          prev-icon="mdi-menu-left"
          next-icon="mdi-menu-right"
          @input="pageChangeEvent"
        />
        <v-spacer />
      </v-card-actions>
    </v-card>
    <edit-entry-pattern-modal
      :enable="enableEditEntryPatternModal"
      :caller-type="targetOrderType"
      :emission-id="emission.id"
      :target-id="targetId"
      @closeCallback="closeModal"
      @registerCallback="registerCallback"
    />
    <show-entry-pattern-modal
      :enable="enableDetailEntryPatternModal"
      :emission-id="emission.id"
      :target-id="targetId"
      :order-type="targetOrderType"
      @closeCallback="closeModal"
    />
    <confirm ref="confirm" />
  </div>
</template>

<style scoped lang="scss">

</style>
